import * as React from 'react'
const SvgChevronRightOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M15.057 12.595a.1.1 0 0 1 0 .141l-6.973 6.987a.75.75 0 0 0 1.062 1.06l7.572-7.588a.75.75 0 0 0 0-1.06l-.005-.004-7.567-7.576a.75.75 0 1 0-1.061 1.06z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgChevronRightOutlined
